<div class="p-booking-info-mdl__additional-item">
  <!-- [11.1] 発着通知連絡先情報追加 -->
  <button
    id="additional-information-arrival-departure-information-button"
    [ngClass]="['p-booking-info-mdl__additional-open', showIsOpenClass ? 'is-open' : '']"
    aria-controls="additional3"
    [attr.aria-expanded]="showIsOpenClass"
    (click)="onClickShutter()"
  >
    <span
      class="p-booking-info-mdl__additional-open-title"
      [innerHTML]="'label.addArrivalDepertureAlerts' | staticMsg"
    ></span>
    <span class="p-booking-info-mdl__additional-open-icon">
      <img src="assets/images/icon_add_primary_20.svg" width="20" height="20" alt="Open"
    /></span>
  </button>
  <div
    *ngIf="showIsOpenClass"
    id="additional3"
    [ngClass]="['p-booking-info-mdl__additional-contents', showIsOpenClass ? 'is-open' : '']"
  >
    <!-- [11.2] 発着通知連絡先情報詳細 -->
    <div class="p-booking-info-mdl__section">
      <div class="p-booking-info-mdl__block">
        <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01">
          <h3 class="p-booking-info-mdl__heading-title">
            {{ 'heading.arrivalDepartureAlertsMail' | staticMsg }}
            <!-- [11.3] ヘルプアイコン ※発着通知連絡先情報見出し -->
            <asw-tooltip
              iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
                'm_static_message-alt.helpIcon2' | staticMsg
              }} width=&quot;20&quot; height=&quot;20&quot;>"
              [tooltipContent]="'tooltip.arrivalDepartureAlerts' | staticMsg"
              [displayAreaClass]="'p-booking-info-mdl__additional-contents'"
            ></asw-tooltip>
          </h3>
        </div>
        <ng-container *ngIf="parts?.isArrivalDepartureNoticeInfoEditable; else showMoreThanThreeEmailsAsLabel">
          <form [formGroup]="formGroup">
            <!-- [11.4] 受信者番号 -->
            <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
              <h4
                class="p-booking-info-mdl__heading-title"
                [innerHTML]="'label.recipientNumber' | staticMsg : { '0': 1 }"
              ></h4>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <!-- [11.5] 発着通知メール受信者 -->
                <asw-input
                  [label]="'label.eMailRecipient' | staticMsg"
                  [placeholder]="'placeholder.eMailRecipient' | staticMsg"
                  [formControlName]="ARRIVAL_DEPARTURE_NOTICE_FORMS.MAIL_RECIPIENT_NAME"
                  (change$)="update(true)"
                  [maxlength]="'28'"
                  [conversionType]="'reserveInfo'"
                ></asw-input>
              </div>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <!-- [11.6] 発着通知メールアドレス -->
                <asw-input
                  [label]="'label.eMailAddress.passengerInput' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [formControlName]="ARRIVAL_DEPARTURE_NOTICE_FORMS.MAIL_ADDRESS"
                  (change$)="update(true)"
                  [maxlength]="'50'"
                  [conversionType]="'email'"
                ></asw-input>
              </div>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <!-- [11.7] 発着通知メールアドレス(確認用) -->
                <asw-input
                  [label]="'label.confirmMailAddress' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  aria-invalid="false"
                  [formControlName]="ARRIVAL_DEPARTURE_NOTICE_FORMS.CONFIRM_MAIL_ADDRESS"
                  (change$)="update(true)"
                  [maxlength]="'50'"
                  [conversionType]="'email'"
                  disablePaste
                ></asw-input>
              </div>
            </div>
            <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
              <h4
                class="p-booking-info-mdl__heading-title"
                [innerHTML]="'label.recipientNumber' | staticMsg : { '0': 2 }"
              ></h4>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <asw-input
                  [label]="'label.eMailRecipient' | staticMsg"
                  [placeholder]="'placeholder.eMailRecipient' | staticMsg"
                  [formControlName]="ARRIVAL_DEPARTURE_NOTICE_FORMS.SECOND_MAIL_RECIPIENT_NAME"
                  (change$)="update(true)"
                  [maxlength]="'28'"
                  [conversionType]="'reserveInfo'"
                ></asw-input>
              </div>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <asw-input
                  [label]="'label.eMailAddress' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [formControlName]="ARRIVAL_DEPARTURE_NOTICE_FORMS.SECOND_MAIL_ADDRESS"
                  (change$)="update(true)"
                  [maxlength]="'50'"
                  [conversionType]="'email'"
                ></asw-input>
              </div>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <div class="p-booking-info-mdl__row-item">
                <asw-input
                  [label]="'label.confirmMailAddress' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [formControlName]="ARRIVAL_DEPARTURE_NOTICE_FORMS.SECOND_CONFIRM_MAIL_ADDRESS"
                  (change$)="update(true)"
                  [maxlength]="'50'"
                  [conversionType]="'email'"
                  disablePaste
                ></asw-input>
              </div>
            </div>
          </form>
        </ng-container>
        <ng-template #showMoreThanThreeEmailsAsLabel>
          <ng-container *ngFor="let email of data?.emails; index as i">
            <div class="p-booking-info-mdl__heading p-booking-info-mdl__heading--02">
              <h4
                class="p-booking-info-mdl__heading-title"
                [innerHTML]="'label.recipientNumber' | staticMsg : { '0': i + 1 }"
              ></h4>
            </div>
            <div class="p-booking-info-mdl__row p-booking-info-mdl__row--01">
              <dl class="c-float-list01">
                <div class="c-float-list01__item">
                  <dt
                    class="c-float-list01__title c-float-list01__title--gray70"
                    [innerHTML]="'label.eMailRecipient' | staticMsg"
                  ></dt>
                  <dd
                    class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                    [innerHTML]="email?.recipient"
                  ></dd>
                </div>
              </dl>
              <dl class="c-float-list01">
                <div class="c-float-list01__item">
                  <dt
                    class="c-float-list01__title c-float-list01__title--gray70"
                    [innerHTML]="'label.eMailAddress' | staticMsg"
                  ></dt>
                  <dd
                    class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                    [innerHTML]="email?.address"
                  ></dd>
                </div>
              </dl>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>
